import Decimal from 'decimal.js';
import parseJson from "../parse-json";
import {BackendFetch} from "@hantera/portal-app";

export interface CatalogSearchHit {
  productNumber: string
  productName: string
  productImage: string
  unitPrice: Decimal
  vatPercentage: Decimal
  availableStock: Decimal
}

export default function (portalFetch: BackendFetch) {

  return {
    /**
     * Product search
     */
    async search(
      phrase: string,
      currencyCode: string,
      countryCode: string,
      locale: string,
      channelKey: string,
      customerNumber: string,
      pricesWithVat: boolean,
      inventoryIds?: string[]
    ): Promise<CatalogSearchHit[]> {
      const res = await portalFetch('/catalog/search', {
        method: 'POST',
        body: JSON.stringify({
          phrase,
          currencyCode,
          countryCode,
          locale,
          channelKey,
          customerNumber,
          pricesWithVat,
          inventoryIds,
        }),
      });

      if (res.status === 200) {
        return parseJson(await res.text());
      }
      return [];
    },
  }
}